import React from 'react';
import { Row } from '@grnhse/seedling/lib/birch/layouts/row';
import ConsentTitle from './consent_title';
import RedirectDestination from './redirect_destination';
import { LogoContainer } from './styled_components';

type Props = {
  name: string;
  companyLogoUrl?: string | null;
  clientIdHost?: string;
  redirectUriHost?: string;
  loopbackOnly?: boolean;
};

export default function ConsentHeader({
  name,
  companyLogoUrl,
  clientIdHost,
  redirectUriHost,
  loopbackOnly,
}: Props) {
  return (
    <>
      <Row spacing={3} justifyContent="space-between">
        <ConsentTitle name={name} clientIdHost={clientIdHost} />
        {companyLogoUrl && (
          <LogoContainer>
            <img src={companyLogoUrl} alt={name} />
          </LogoContainer>
        )}
      </Row>
      {redirectUriHost && (
        <RedirectDestination
          host={redirectUriHost}
          loopbackOnly={loopbackOnly}
        />
      )}
    </>
  );
}
